import React from 'react';
import PropTypes from 'prop-types';
import ObjectKey from './ObjectKey';

export default class ObjectField extends React.Component {

  // TODO: Review proptypes validations
  static propTypes = {
    formData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    properties: PropTypes.object,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object
  }

  render() {
    const { formData, onChange, schema, uiSchema } = this.props;
    const orderedKeys = uiSchema['ui:order'] || Object.keys(schema.properties);
    return (
      <div>
        {orderedKeys.map((key, index) => (
          <div key={index} style={{ marginBottom: '4em' }}>
            <ObjectKey
              schema={schema.properties[key]}
              uiSchema={uiSchema[key]}
              formData={formData && formData[key]}
              onChange={onChange}
              fieldID={key}
            />
          </div>
        ))}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/Object.js